// src/config.js
const AppConfig = {
    title: "عبداللە خڕنووکی پارە خۆرەکەی پێنجوێن بناسن",
    paragraph: "TikTok",
    img: "https://i.postimg.cc/8P7KddkD/FB-IMG-1761237987331.jpg",
    url: "abdulla",
    id: "5231025"
};

export default AppConfig;